import './search-form-collapsible';



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/search/global-search/index.js